import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";


interface IListTimeAssignmentsProps {
  scheduleFrom: string;
  scheduleTo: string;
}

export const getTaskAssignmentsWithSchedules = async ({ scheduleFrom, scheduleTo }: IListTimeAssignmentsProps) => {
  try {
    console.log('🔄 Fetching assignments:', { scheduleFrom, scheduleTo });
    console.log('🌐 API URL:', apiClientSource.defaults.baseURL);
    
    const url = `/task-service/api/tasks-schedule/assignments-with-schedules?scheduleFrom=${scheduleFrom}&scheduleTo=${scheduleTo}`;
    console.log('📡 Full URL:', `${apiClientSource.defaults.baseURL}${url}`);
    
    const response = await apiClientSource.get(url);
    console.log('✅ Assignments response:', response.data);
    return response.data;
  } catch (error: unknown) {
    console.error('❌ Assignments API error:', error);
    const axiosError = error as Error & { 
      code?: string; 
      response?: { 
        status?: number; 
        statusText?: string; 
        data?: unknown; 
      }; 
    };
    console.error('❌ Error details:', {
      message: axiosError.message,
      status: axiosError.response?.status,
      statusText: axiosError.response?.statusText,
      data: axiosError.response?.data,
      baseURL: apiClientSource.defaults.baseURL,
      code: axiosError.code,
      fullURL: `${apiClientSource.defaults.baseURL}/task-service/api/tasks-schedule/assignments-with-schedules`
    });
    
    // Log específico para diferentes tipos de errores
    if (axiosError.response?.status === 404) {
      console.warn('🔍 API endpoint not found - this is expected if the backend service is not deployed');
    } else if (axiosError.code === 'ERR_NETWORK') {
      console.warn('🌐 Network error - check if the backend server is running');
    } else if (axiosError.code === 'ERR_CORS') {
      console.warn('🚫 CORS error - backend needs to allow requests from this domain');
    }
    
    // Para errores 404, 500, CORS, red, etc. - devolver array vacío para evitar crashes
    if (
      axiosError.code === 'ECONNABORTED' || 
      axiosError.code === 'ERR_NETWORK' || 
      axiosError.code === 'ERR_CORS' ||
      !axiosError.response ||
      axiosError.response?.status === 404 ||
      (axiosError.response?.status && axiosError.response.status >= 500)
    ) {
      console.warn('🔄 API not available, returning empty array to prevent crash');
      console.warn('🔄 This allows the app to continue working while the API is fixed');
      return [];
    }
    
    // Para otros errores (401, 403, etc.) seguir el flujo normal
    handleAxiosError(error, "Error al listar las asignaciones de tiempo");
    throw error;
  }
};
